
document.addEventListener('DOMContentLoaded', function () {
  const orderInput = document.getElementById('external_order_id');
  const addToCartBtn = document.querySelector('.product-form__submit');
  // const errorMsg = document.getElementById('order-id-error');

  if (!orderInput || !addToCartBtn) return;

  // Button disabled by default
  addToCartBtn.disabled = true;

  orderInput.addEventListener('input', function () {
   
    if (orderInput.value.length >= 6) {
      addToCartBtn.disabled = false;
      // errorMsg.style.display = 'block';
    } else {
      addToCartBtn.disabled = true;
      // errorMsg.style.display = orderInput.value.length > 0 ? 'block' : 'none';
    }
  });
});
